<template>
    <like-link :likeLayout="likeLayout" :likeData="likeData"></like-link>
</template>

<script>
import likeUtil from "@/components/like/likeUtil";
import LikeLink from "@/components/like/LikeLink";
import EventBus from "@/utils/event-bus";
import {mapState} from "vuex";

export default {
    name: "LikeCompetitionComponent",
    mixins: [likeUtil],
    components: {LikeLink},
    inject: [],
    provide() {
        return {}
    },
    props: {
        likeType: '',
        likeData: {}
    },
    data() {
        return {
            likeLayout: '',
            writeFunc: '',
            keyName: '',
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig();
    },
    mounted() {
        EventBus.$on('like', this.like);
    },
    beforeDestroy() {
        EventBus.$off('like');
    },
    destroyed() {
    },
    computed: {

    },
    methods: {
        initConfig() {
            let config = this.returnLikeConfig(this.likeType)
            this.likeLayout = config.likeLayout;
            this.writeFunc = config.writeFunc;
            this.keyName = config.keyName;
        },
        like() {
            let params = {}
            params[this.keyName] = this.likeData.c_idx
            try {
                this.$api.$competition[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type === 1) {
                        this.likeAfterFunc()
                    }
                })
            }catch (e) {
                console.log(e)
            }

        },
        likeAfterFunc() {
            if (!this.likeData.LikeStatus) {
                this.likeData.likeCnt = this.likeData.likeCnt + 1;
            } else {
                this.likeData.likeCnt = this.likeData.likeCnt - 1;
            }
            this.likeData.LikeStatus = !this.likeData.LikeStatus;
            this.$forceUpdate();
        }

    },
    watch: {},
}
</script>

<style scoped>

</style>
